import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {dhms} from '../../utils/timers';

export default class CountdownTimer extends React.PureComponent {
  static propTypes = {
    until: PropTypes.any.isRequired
  };

  constructor(props) {
    super(props);

    this.state = dhms(Date.parse(props.until) - Date.now());
  }

  tick = () => {
    const {until} = this.props;

    this.setState(dhms(Date.parse(until) - Date.now()));
  };

  componentDidMount() {
    this._timer = setInterval(this.tick, 60000);
  }

  componentWillUnmount() {
    clearInterval(this._timer);
  }

  render() {
    const {days, hours, minutes} = this.state;

    // TODO: add declensions for future russian translation
    return (
      <div className="special-product__countdown">
        <div className="special-product__countdown-item">
          <div className="special-product__countdown-top">
            {days < 0 ? 0 : days}
          </div>
          <div className="special-product__countdown-bottom">
            <FormattedMessage id="section.countdown.days"/>
          </div>
        </div>

        <div className="special-product__countdown-item">
          <div className="special-product__countdown-top">
            {hours < 0 ? 0 : hours}
          </div>
          <div className="special-product__countdown-bottom">
            <FormattedMessage id="section.countdown.hours"/>
          </div>
        </div>

        <div className="special-product__countdown-item">
          <div className="special-product__countdown-top">
            {minutes < 0 ? 0 : minutes}
          </div>
          <div className="special-product__countdown-bottom">
            <FormattedMessage id="section.countdown.minutes"/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/countdownTimer/CountdownTimer.js